/* This wraps around all routes */

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NotFoundPage from './NotFoundPage';
import LoginPage from './LoginPage';
import SetupAccountWizardPage from './SetupAccountWizardPage';
import RequestPasswordResetPage from './RequestPasswordResetPage';
import ResetPasswordWizardPage from './ResetPasswordWizardPage';
import LabsPage from '../components/labs/LabsPage';
import LabResultsPage from '../components/labs/LabResultsPage';
import SurveysPage from '../components/surveys/SurveysPage';
import SurveysResponsePage from '../components/surveys/SurveyResponsePage';
import NoteHistory from '../components/noteHistory/NoteHistory';
import NotePage from '../components/noteHistory/NotePage';
import ProfilePage from '../components/profile/ProfilePage';
import ChangePasswordPage from '../components/profile/ChangePasswordPage';
import ChangeSecurityQuestionsPage from '../components/profile/ChangeSecurityQuestionsPage';
import WellnessSurveyHome from '../components/home/WellnessSurveyHome';
import FreeTextSurvey from '../components/home/FreeTextSurvey';
import LabRequisitionHome from '../components/home/LabRequisitionHome';
import RestLinkExpiredPage from '../components/ResetLinkExpiredPage';
import ProfileAccountDetailsPage from '../components/profile/ProfileAccountDetailsPage';
import PrivacyPolicyPage from '../components/profile/PrivacyPolicyPage';
import HelpCentrePage from '../components/profile/HelpCentrePage';
import OnePlusAuthentication from '../components/login/OnePlusAuthentication';
import CalendarTestInfoPage from '../components/calendar/CalendarTestInfoPage';
import GuardedTaskHome from '../components/home/TaskHome';
import TaskHome from '../components/home/TaskHome';
import DoctorNote from '../components/home/DoctorNote';
import {
    PATH_LOGIN,
    PATH_WELLNESS_SURVEY_HOME,
    PATH_WELLNESS_SURVEY_QUESTION,
    PATH_LAB_REQUISITION,
    PATH_ONBOARDING_TUTORIAL,
    PATH_HOME,
    PATH_DOCTOR_NOTE,
    PATH_NOTES,
    PATH_LABS_PSA,
    PATH_LABS_TESTOSTERONE,
    PATH_LABS_HCG,
    PATH_LABS_AFP,
    PATH_LABS_LDH,
    PATH_LABS_FSH,
    PATH_LABS_LH,
    PATH_SURVEY_RESPONSES,
    PATH_LABS,
    PATH_RESET_LINK_EXPIRED,
    PATH_PROFILE_PASSWORD,
    PATH_PROFILE_SECURITY_QUESTIONS,
    PATH_PROFILE_ACCOUNT_DETAILS,
    PATH_PROFILE_PRIVACY_POLICY,
    PATH_HELP_CENTRE,
    PATH_ONE_PLUS_AUTHENTICATION,
    PATH_FREE_TEXT_SURVEY_HOME,
    PATH_CALENDAR_TUTORIAL,
    PATH_CALENDAR,
    PATH_CALENDAR_INFO,
    PATH_CHAT,
    PATH_IMAGING,
    PATH_TERMS_AND_CONDITIONS,
} from './RoutePaths';
import WellnessSurveyQuestion from '../components/home/WellnessSurveyQuestion';
import GuardedCalendarPage from '../components/calendar/CalendarPage';
import { ChatPageRedirectWrapper } from '../components/chat/ChatPageRedirectWrapper';
import ImagingHome from '../components/home/ImagingHome';
import TermsAndConditionsPage from '../components/profile/TermsAndConditionsPage';

const Routes = ({ isWatchman = false }) => {
    let extraRoutes;

    if (isWatchman) {
        extraRoutes = [
            <Route exact path={PATH_ONBOARDING_TUTORIAL} key={PATH_ONBOARDING_TUTORIAL} component={() => <GuardedTaskHome isTutorial={true} />} />,
            <Route exact path={PATH_CALENDAR} key={PATH_CALENDAR} component={GuardedCalendarPage} />,
            <Route exact path={PATH_CALENDAR_TUTORIAL} key={PATH_CALENDAR_TUTORIAL} component={() => <GuardedCalendarPage isShowTutorial={true} />} />,
            <Route exact path={PATH_CALENDAR_INFO} key={PATH_CALENDAR_INFO} component={CalendarTestInfoPage} />,
            <Route exact path={PATH_CHAT} key={PATH_CHAT} component={ChatPageRedirectWrapper} />,
            <Route exact path={PATH_TERMS_AND_CONDITIONS} key={PATH_TERMS_AND_CONDITIONS} component={TermsAndConditionsPage} />,
        ];
    }

    return (
        <Switch>
            <Route exact path="/" component={LoginPage} />
            <Route exact path="/patient" component={LoginPage} />
            <Route exact path={PATH_LOGIN} component={LoginPage} />
            <Route exact path="/patient/login/requestPasswordReset" component={RequestPasswordResetPage} />
            <Route exact path={PATH_HOME} component={TaskHome} />
            <Route exact path={PATH_NOTES} component={NoteHistory} />
            <Route exact path={PATH_NOTES.concat('/:id')} component={NotePage} />
            <Route exact path="/patient/profile" component={ProfilePage} />
            <Route exact path={PATH_WELLNESS_SURVEY_HOME} component={WellnessSurveyHome} />
            <Route exact path={PATH_FREE_TEXT_SURVEY_HOME} component={FreeTextSurvey} />
            <Route exact path={PATH_WELLNESS_SURVEY_QUESTION} component={WellnessSurveyQuestion} />
            <Route exact path={PATH_LAB_REQUISITION} component={LabRequisitionHome} />
            <Route exact path={PATH_IMAGING} component={ImagingHome} />
            <Route exact path={PATH_DOCTOR_NOTE} component={DoctorNote} />
            <Route exact path={PATH_LABS} component={LabsPage} />
            <Route exact path={PATH_LABS_PSA} component={LabResultsPage} />
            <Route exact path={PATH_LABS_TESTOSTERONE} component={LabResultsPage} />
            <Route exact path={PATH_LABS_HCG} component={LabResultsPage} />
            <Route exact path={PATH_LABS_AFP} component={LabResultsPage} />
            <Route exact path={PATH_LABS_LDH} component={LabResultsPage} />
            <Route exact path={PATH_LABS_FSH} component={LabResultsPage} />
            <Route exact path={PATH_LABS_LH} component={LabResultsPage} />
            <Route exact path="/patient/surveys" component={SurveysPage} />
            <Route exact path={PATH_SURVEY_RESPONSES.concat(':id')} component={SurveysResponsePage} />
            <Route exact path="/patient/accountSetup" component={SetupAccountWizardPage} />
            <Route path="/patient/passwordreset" component={ResetPasswordWizardPage} />
            <Route exact path={PATH_PROFILE_PASSWORD} component={ChangePasswordPage} />
            <Route exact path={PATH_PROFILE_SECURITY_QUESTIONS} component={ChangeSecurityQuestionsPage} />
            <Route exact path={PATH_PROFILE_ACCOUNT_DETAILS} component={ProfileAccountDetailsPage} />
            <Route exact path={PATH_PROFILE_PRIVACY_POLICY} component={PrivacyPolicyPage} />
            <Route exact path={PATH_HELP_CENTRE} component={HelpCentrePage} />
            <Route exact path={PATH_RESET_LINK_EXPIRED} component={RestLinkExpiredPage} />
            <Route exact path={PATH_ONE_PLUS_AUTHENTICATION} component={OnePlusAuthentication} />
            {extraRoutes}
            <Route component={NotFoundPage} />
        </Switch>
    );
};

export default Routes;
